import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import { Button, CardActions } from '@mui/material'
import { capitalize } from 'lodash'
import { useTranslate } from 'ra-core'
import * as React from 'react'

import GoogleIcon from '../icons/GoogleIcon'
import MicrosoftIcon from '../icons/MicrosoftIcon'
export const ssoProviders = [
  { key: 'google', Icon: GoogleIcon },
  { key: 'microsoft', Icon: MicrosoftIcon },
  { key: 'saml', Icon: AccountCircleIcon },
]

const SSOButton = ({ provider, disabled, onClick, startIcon }) => {
  const translate = useTranslate()

  const IconComponent = ssoProviders.find((p) => p.key === provider)?.Icon

  return (
    <CardActions sx={{ justifyContent: 'center' }}>
      <Button
        disabled={disabled}
        sx={{
          width: '100%',
          backgroundColor: '#F5F5F5',
          borderRadius: '4px',
          boxShadow: '0 2px 2px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .24)',
          color: 'black',
          '&:hover': {
            backgroundColor: '#C2C2C2',
          },
          '&:disabled': {
            boxShadow: 'none',
            color: '#8F8F8F',
            backgroundColor: '#595959',
          },
        }}
        onClick={onClick}
        startIcon={startIcon ?? <IconComponent />}
      >
        {translate(`mymove.login.signInWith${capitalize(provider)}`)}
      </Button>
    </CardActions>
  )
}

export default SSOButton
